import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import ContentCard from 'components/ContentCard/ContentCard';
import LoadingButton from 'components/LoadingButton/LoadingButton';
import routeDefinitions from 'enum/routeDefinitions';
import allUserGroups from 'enum/userGroups';

import upcomingShowPic from '../../../images/upcomingShow.png';

import UpcomingShowsStore from './UpcomingShowsStore';
import styles from './UpcomingShows.css';


const UpcomingShows = (props) => {
  const { history } = props;
  const [flowInitiated, setFlowInitiated] = useState(false);
  const {
    isPerformerFavorited,
    profileName,
    showRegistrationModal,
    handleToggleFavorite,
    isLoadingFavoritesButton,
    userFavoriteSuccess,
  } = ProfileStore;
  const {
    user: { username },
    isLoggedIn,
    hasCF,
    isGuestBilling,
  } = UserStore;
  const watchingOwnProfile = isLoggedIn && profileName.toLowerCase() === username.toLowerCase();
  const v2calendar = hasCF(allUserGroups.CALENDAR_V2);
  const calendarRoute = routeDefinitions.get(
    v2calendar ? routeDefinitions.calendar : routeDefinitions.performerCalendar,
    { user: username }
  );
  const subscribed = isPerformerFavorited || watchingOwnProfile;

  const redirectToCalendar = useCallback(() => {
    if (v2calendar) {
      history.push(calendarRoute);
    } else {
      window.location = calendarRoute;
    }
  }, [calendarRoute, history, v2calendar]);

  useEffect(() => {
    if (userFavoriteSuccess && flowInitiated) {
      redirectToCalendar();
    }
  }, [userFavoriteSuccess, redirectToCalendar, flowInitiated]);

  const handleVisitCalendar = useCallback(() => {
    if (isGuestBilling) {
      ModalService.showModal(ModalService.MODAL_KEYS.GUEST_BILLING_MODAL, {
        close: ModalService.hideModal,
        show: true,
      });
    } else if (!isLoggedIn) {
      showRegistrationModal();
    } else if (isPerformerFavorited) {
      redirectToCalendar();
    } else {
      setFlowInitiated(true);
      handleToggleFavorite(username);
    }
  }, [
    handleToggleFavorite,
    isGuestBilling,
    isLoggedIn,
    isPerformerFavorited,
    redirectToCalendar,
    showRegistrationModal,
    username,
  ]);

  const button = (
    <LoadingButton
      className={styles.visitBtn}
      colorVariant="white"
      fullWidth={true}
      isLoading={isLoadingFavoritesButton}
      onClick={handleVisitCalendar}
    >
      {subscribed ? translate('v2profile.visit.calendar') : translate('v2profile.subscribe.and.visit.calendar')}
    </LoadingButton>
  );

  return (
    <ContentCard
      className={styles.contentCard}
      footer={watchingOwnProfile ? null : button}
      footerClass={styles.footer}
      title={translate('v2profile.upcoming.shows')}
    >
      {UpcomingShowsStore.firstThreeShows.map((show) => (
        <div key={`${show.showTime}-${show.dateNumber}`} className={styles.showWrapper}>
          <div className={styles.timeWrap}>
            <img alt="upcoming show" className={styles.icon} src={upcomingShowPic} />
            <span>
              {show.monthName} {show.dateNumber}
            </span>
            <span className={styles.showTime}> - {show.showTime}</span>
          </div>
        </div>
      ))}
    </ContentCard>
  );
};

UpcomingShows.propTypes = { history: PropTypes.object.isRequired };

export default observer(UpcomingShows);
